export class NewEquivalence {
  tableauId: number;
  fromCompetences: Array<number>;
  toCompetences: Array<number>;
  statut: number;
}
